import { render, staticRenderFns } from "./e-tv-preview.vue?vue&type=template&id=52bf23cb&scoped=true"
import script from "./e-tv-preview.vue?vue&type=script&lang=js"
export * from "./e-tv-preview.vue?vue&type=script&lang=js"
import style0 from "./e-tv-preview.vue?vue&type=style&index=0&id=52bf23cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bf23cb",
  null
  
)

export default component.exports